/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_DescriptionInputs */

const en_settings_tickets_create_description = /** @type {(inputs: Settings_Tickets_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your issue and we'll respond as soon as possible`)
};

/**
* | output |
* | --- |
* | "Describe your issue and we'll respond as soon as possible" |
*
* @param {Settings_Tickets_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_description = /** @type {((inputs?: Settings_Tickets_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_create_description(inputs)
});
export { settings_tickets_create_description as "settings.tickets.create_description" }